import React from 'react'
import {listingsTxt} from './listingsTxt'
import {ListingItem} from './ListingItem'
// nore == 'news' or 'events'
export function Listings({nore}) {
  const obj = listingsTxt[nore]
  let index = 0
  return(
    <div>
      {obj.map((listing) => {
      index++
      return(
        <div key={index}>
          <ListingItem key={index} atype={nore} index={index-1}/>
        </div>
      )
      })}
    </div>
  )
}

